<template>
  <Loading :title="loadingTitleText" :description="loadingDescription || undefined" fullscreen />
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { Loading } from "@payjoy/design-system";

export default defineComponent({
  name: "PageLoading",
  components: { Loading },
  props: {
    loadingTitle: { type: String, default: "" },
    loadingDescription: { type: String, default: "" },
  },
  setup(props) {
    const { t } = useI18n();

    const loadingTitleText = computed(() => (props.loadingTitle ? props.loadingTitle : t("loading")));

    return {
      loadingTitleText,
    };
  },
});
</script>
